export enum CMDS {
    PLAYER_DIE = 'D',
    PLAYER_MOVE = 'M',
    PLAYER_STOP = 'S',
    PLAYER_STATE_UPDATE = 'P',
    BOMB_SPAWN = 'B',
    BOMB_EXPLODE = 'X',
    MESSAGE_CLIENT = 'C',
    ROOM_BUNT = 'ROOM_BUNT',
    ROOM_ENTER = 'ROOM_ENTER',
    ROOM_EXIT = 'ROOM_EXIT',
    ROOM_STATE_UPDATE = 'ROOM_STATE_UPDATE',
    SCENE = 'SCENE',
}

export enum GAMETYPES {
    BATTLE = 'b',
    CAMPAIGN = 'c',
}

export enum CHARACTERS {
    BOMBERMAN_TINY = 'bomberman-tiny', 
    DAISY = 'daisy', 
    LUIGI = 'luigi', 
    MARIO = 'mario', 
    PEACH = 'peach', 
    TOAD = 'toad', 
    TOADSWORTH = 'toadsworth', 
    WARIO = 'wario',
}
